export default {
  list: [
    {
      value: 'INCREASE_BY_ONLINE_PAYMENT',
      title: 'افزایش اعتبار با پرداخت آنلاین',
    },
    {
      value: 'USER_FREE_CREDIT_AMOUNT_BY_COMPLETING_PROFILE',
      title: 'افزایش اعتبار با تکمیل پروفایل',
    },
    {
      value: 'ONLINE_PAYMENT_BY_RESERVATION',
      title: 'پرداخت آنلاین بابت رزرو',
    },
    {
      value: 'CREDIT_PAYMENT_BY_RESERVATION',
      title: 'پرداخت از اعتبار بابت رزرو',
    },
    {
      value: 'INCREASE_CREDIT_BY_CANCEL_RESERVATION',
      title: 'افزایش اعتبار با کنسل کردن رزرو',
    }, {
      value: 'INCREASE_CREDIT_BY_REJECT_RESERVATION',
      title: 'افزایش اعتبار با رد شدن رزرو',
    },
  ],
  values: {
    ONLINE_PAYMENT_BY_RESERVATION: 'ONLINE_PAYMENT_BY_RESERVATION',
    CREDIT_PAYMENT_BY_RESERVATION: 'CREDIT_PAYMENT_BY_RESERVATION',
    INCREASE_BY_ONLINE_PAYMENT: 'INCREASE_BY_ONLINE_PAYMENT',
    USER_FREE_CREDIT_AMOUNT_BY_COMPLETING_PROFILE: 'USER_FREE_CREDIT_AMOUNT_BY_COMPLETING_PROFILE',
    INCREASE_CREDIT_BY_CANCEL_RESERVATION: 'INCREASE_CREDIT_BY_CANCEL_RESERVATION',
    INCREASE_CREDIT_BY_REJECT_RESERVATION: 'INCREASE_CREDIT_BY_REJECT_RESERVATION',
  },
};
